// extracted by mini-css-extract-plugin
export default {"fill":"Searchbar_fill__4meM1"};